export const uniqueObjectArray = <T>(arr: T[]): T[] =>
  arr.filter((value, index) => {
    const _value = JSON.stringify(value).toLowerCase();
    return (
      index ===
      arr.findIndex((obj) => JSON.stringify(obj).toLowerCase() === _value)
    );
  });

export const isPathnameInRoutes = (
  pathname: string,
  routes: string[]
): boolean => {
  return routes.some((route) => pathname.includes(route));
};

export const groupByKey = <T = Record<string, string>>(
  data: T[],
  key: keyof T
) =>
  data.reduce(
    (acc, curr) => {
      const keyName = String(curr[key]);
      if (!acc[keyName]) {
        acc[keyName] = [];
      }
      acc[keyName].push(curr);
      return acc;
    },
    {} as Record<string, T[]>
  );
